import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar, Pie, Scatter } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale, LinearScale, BarElement, PointElement, LineElement,
  ArcElement, Title, Tooltip, Legend
);

const COLORS = [
  '#667eea', '#764ba2', '#00b894', '#e17055', '#fdcb6e',
  '#0984e3', '#6c5ce7', '#00cec9', '#fab1a0', '#74b9ff',
  '#a29bfe', '#55efc4', '#ff7675', '#ffeaa7', '#dfe6e9',
];

export function WinRateChart({ bidders }) {
  if (!bidders || bidders.length === 0) return null;

  const data = {
    labels: bidders.map((b) => b.bidderCode),
    datasets: [{
      label: 'Win Rate %',
      data: bidders.map((b) => ((b.winRate || 0) * 100).toFixed(1)),
      backgroundColor: COLORS.slice(0, bidders.length),
    }],
  };

  return (
    <div className="chart-card">
      <h3>Win Rate by Bidder</h3>
      <Bar data={data} options={{ indexAxis: 'y', plugins: { legend: { display: false } } }} />
    </div>
  );
}

export function AvgCpmChart({ bidders }) {
  if (!bidders || bidders.length === 0) return null;

  const data = {
    labels: bidders.map((b) => b.bidderCode),
    datasets: [{
      label: 'Avg CPM ($)',
      data: bidders.map((b) => b.avgCpm || 0),
      backgroundColor: COLORS.slice(0, bidders.length),
    }],
  };

  return (
    <div className="chart-card">
      <h3>Average CPM by Bidder</h3>
      <Bar data={data} options={{ plugins: { legend: { display: false } } }} />
    </div>
  );
}

export function RevenueShareChart({ bidders }) {
  if (!bidders || bidders.length === 0) return null;

  const filtered = bidders.filter((b) => b.totalRevenue > 0);
  const data = {
    labels: filtered.map((b) => b.bidderCode),
    datasets: [{
      data: filtered.map((b) => b.totalRevenue),
      backgroundColor: COLORS.slice(0, filtered.length),
    }],
  };

  return (
    <div className="chart-card">
      <h3>Revenue Share by Bidder</h3>
      <Pie data={data} />
    </div>
  );
}

export function ResponseTimeVsCpmChart({ latencyBidders, winBidders }) {
  if (!latencyBidders || latencyBidders.length === 0) return null;

  const datasets = latencyBidders.map((b, i) => {
    const winBidder = winBidders?.find((w) => w.bidderCode === b.bidderCode);
    return {
      label: b.bidderCode,
      data: [{
        x: b.responseTimeStats?.median || 0,
        y: winBidder?.avgWinningCpm || winBidder?.avgBidCpm || 0,
      }],
      backgroundColor: COLORS[i % COLORS.length],
      pointRadius: 8,
    };
  });

  return (
    <div className="chart-card">
      <h3>Response Time vs CPM</h3>
      <Scatter
        data={{ datasets }}
        options={{
          scales: {
            x: { title: { display: true, text: 'Median Response Time (ms)' } },
            y: { title: { display: true, text: 'Avg CPM ($)' } },
          },
        }}
      />
    </div>
  );
}
